"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var owa_diagnostics_1 = require("owa-diagnostics");
var DiagnosticsPane = function (props) {
    return React.createElement(owa_diagnostics_1.DiagnosticsPanel, { onDismiss: props.onDismiss });
};
exports.default = DiagnosticsPane;
//# sourceMappingURL=DiagnosticsPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/DiagnosticsPane.js
// module id = 6197
// module chunks = 38